import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dec1442a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "orderRemark"
};
const _hoisted_2 = {
  class: "header-back"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "seizes"
}, null, -1));
const _hoisted_4 = {
  class: "render-fixed-top drop-back"
};
const _hoisted_5 = ["textContent"];
const _hoisted_6 = {
  class: "box"
};
const _hoisted_7 = {
  class: "tip"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
    name: "title_name",
    textContent: _toDisplayString('申诉理由')
  }, null, 8, _hoisted_5), _createElementVNode("div", {
    class: "drop-back-icon",
    onClick: _cache[0] || (_cache[0] = $event => $options.dialogBack())
  }), _createElementVNode("div", {
    class: "sub",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.sub && $options.sub(...args))
  }, "提交")])]), _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("textarea", {
    name: "",
    class: "textarea",
    cols: "30",
    rows: "10",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.mes = $event),
    maxlength: "100",
    placeholder: "申诉理由..."
  }, null, 512), [[_vModelText, $data.mes]]), _createElementVNode("div", _hoisted_7, _toDisplayString($data.mes.length) + "/100", 1)])]);
}